import type { Persona } from "./persona"

export const HERO_HEADER_VIEW_COOKIE_NAME = "heroHeaderView"

export const HERO_HEADER_VIEW = {
  full: "full",
  compact: "compact",
} as const

export type HeroHeaderView = keyof typeof HERO_HEADER_VIEW
export type HeroHeaderMediaType = "image" | "video"

/**
 * The default header view is based on the persona
 */
export const getDefaultHeroHeaderView = (persona: Persona) => {
  return persona === "collector"
    ? HERO_HEADER_VIEW.full
    : HERO_HEADER_VIEW.compact
}

export function parseHeroHeaderView(
  headerView: string | undefined,
  persona: Persona,
): HeroHeaderView {
  if (headerView && headerView in HERO_HEADER_VIEW) {
    return headerView as HeroHeaderView
  }

  return getDefaultHeroHeaderView(persona)
}

const heroHeaderViews = Object.values(HERO_HEADER_VIEW)

export function getHeroHeaderViewStaticParams() {
  return heroHeaderViews.map(heroHeaderView => ({ heroHeaderView }))
}
